import { Alert, Typography } from "@mui/material";
import { StyledButtonMain } from "../../common/Buttons";

interface CaseReferralBannerProps {
  // The client of the ?case_id= link could not be loaded.
  failed: boolean;
  companyName?: string;
  hint: string;
  onBack: () => void;
}

// "Referring for: <client>" on a directory opened from a case's referral
// link. DirectoryLayout pins it to the top of the screen: the lists are long,
// so the consultant must see which client the referral is for without
// scrolling back up.
const CaseReferralBanner = ({
  failed,
  companyName,
  hint,
  onBack,
}: CaseReferralBannerProps) => (
  <Alert
    icon={false}
    severity={failed ? "warning" : "info"}
    sx={{
      position: "relative",
      borderLeft: "5px solid #9D2362",
      backgroundColor: failed ? "#FDF4E5" : "#FBEFF5",
      color: "#3F1229",
      boxShadow: "0 2px 6px rgba(63, 18, 41, 0.15)",
      //The text is centred on the banner as a whole, so from sm up the
      //action is lifted out of the flex flow and the message gets
      //matching gutters; on xs it stays in flow so it cannot overlap.
      "& .MuiAlert-message": {
        flexGrow: 1,
        textAlign: "center",
        paddingLeft: { xs: 0, sm: "150px" },
        paddingRight: { xs: 0, sm: "150px" },
      },
      "& .MuiAlert-action": {
        alignItems: "center",
        paddingTop: 0,
        marginLeft: 0,
        position: { xs: "static", sm: "absolute" },
        right: { sm: "16px" },
        top: { sm: "50%" },
        transform: { sm: "translateY(-50%)" },
      },
    }}
    action={
      <StyledButtonMain variant="contained" size="small" onClick={onBack}>
        Back to Case
      </StyledButtonMain>
    }
  >
    {failed ? (
      <Typography variant="body1">
        We could not load the client for this referral link. Please go back to
        the case and try again.
      </Typography>
    ) : (
      <>
        <Typography variant="body1">
          Referring for: <strong>{companyName || "Loading client…"}</strong>
        </Typography>
        <Typography variant="body2">{hint}</Typography>
      </>
    )}
  </Alert>
);

export default CaseReferralBanner;
